import React from "react";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";

interface PricingToggleProps {
  isYearly: boolean;
  onToggle: (yearly: boolean) => void;
}

export const PricingToggle: React.FC<PricingToggleProps> = ({
  isYearly,
  onToggle,
}) => (
  <div className="flex items-center justify-center space-x-4 mb-8">
    <Label
      className={`text-sm font-medium ${
        !isYearly ? "text-primary" : "text-muted-foreground"
      }`}
    >
      Monthly
    </Label>
    <Switch
      checked={isYearly}
      onCheckedChange={onToggle}
      className="data-[state=checked]:bg-primary"
    />
    <div className="flex items-center space-x-2">
      <Label
        className={`text-sm font-medium ${
          isYearly ? "text-foreground" : "text-muted-foreground"
        }`}
      >
        Yearly
      </Label>
      <Badge
        variant="secondary"
        className="bg-green-50 text-green-600 border-green-300 border-dashed hover:bg-green-50 text-xs px-2 py-0.5 rounded-sm"
      >
        Save 20%
      </Badge>
    </div>
  </div>
);
